import Swiper, { Autoplay, Navigation, Grid } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let benefitsSwiperWr = document.querySelectorAll('.benefits-swiper-wr');
benefitsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Grid],
      speed: 800,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
        slidesPerView: 1,
        spaceBetween: 15,
        grid: {
            rows: 2,
        },
      breakpoints: {
          450: {
              slidesPerView: 2,
              grid: {
                  rows: 2,
              },
          },
          750: {
              slidesPerView: 3,
              grid: {
                  rows: 2,
              },
          },
        1100: {
            spaceBetween: 15,
            slidesPerView: 4,
            grid: {
                rows: 2,
            },
        },
          1300: {
              spaceBetween: 30,
              slidesPerView: 4,
              grid: {
                  rows: 2,
              },
          },

      },
       autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },

    });
    swiperObserver(swiper);
  }
});
